// `//host` and `/\host` resolve to another origin, and so does a path with whitespace: browsers drop
// tabs and newlines from a URL before reading it.
export const isInternalPath = (href: string): boolean => /^\/(?![/\\])\S*$/.test(href);
